<script setup lang="ts">
import type { ImageMap } from '@/services/productImage'
import type { Subscription } from '@/services/subscription'

import ProductImage from '@/components/ProductImage.vue'
import Button from '@/components/Button.vue'
import IconCalendarJumpToDate from '@/assets/icons/calendar-jump-to-date.svg?component'

import { formatMoneyWithCurrency } from '@/lib/formatters/money'

defineProps<{
  subscription: Subscription
  images: ImageMap[] | null | undefined
  working: boolean
}>()

const emit = defineEmits<{
  (e: 'add-to-next-order', subscriptionId: number): void
}>()
</script>

<template>
  <div class="NextOrderUpsellItem">
    <div class="NextOrderUpsellItem__Image">
      <ProductImage
        :url="images && images[0] ? images[0].small : undefined"
        :alt="subscription.product_title"
      />
    </div>
    <div class="NextOrderUpsellItem__Details">
      <p>
        {{ subscription.product_title }}
        <template v-if="subscription.variant_title"
          >– {{ subscription.variant_title }}</template
        >
      </p>
      <p class="NextOrderUpsellItem__Price">
        {{ formatMoneyWithCurrency(subscription.price) }}
      </p>
      <div class="NextOrderUpsellItem__Actions">
        <Button
          :link="true"
          :loading="working"
          :disabled="working"
          @click="emit('add-to-next-order', subscription.id)"
        >
          <template #iconBefore>
            <IconCalendarJumpToDate />
          </template>
          Add to next order
        </Button>
      </div>
    </div>
  </div>
</template>

<style>
.NextOrderUpsellItem {
  display: flex;
  gap: 16px;
  align-items: center;
}

.NextOrderUpsellItem__Image {
  position: relative;

  & img {
    height: 88px;
    width: 88px;
    border-radius: 4px;
  }

  & .NextOrderUpsellItem__Quantity {
    position: absolute;
    top: -4px;
    right: -4px;
    background-color: var(--color-lichen-100);
    font-size: 14px;
    border-radius: 1000px;
    padding: 1px 7px;
  }
}

.NextOrderUpsellItem__Details {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;

  & p {
    margin: 0;
  }
}

.NextOrderUpsellItem__Price {
  font-weight: bold;
}

.NextOrder__Totals {
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.NextOrder__Total {
  display: flex;
  align-items: first baseline;
  justify-content: space-between;

  & p {
    margin: 0;
  }
}

.NextOrder__DeliveryDetails {
  padding: 20px;
}

.NextOrderUpsellItem__Actions {
  display: flex;
  gap: 12px;
}
</style>
